import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { InfoReportService } from 'src/app/services/info-report.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { AppPermissions } from 'src/app/shared/app.permissions';
import { RemoveIfUnauthorizedIRDirective } from 'src/app/shared/directives/remove-if-unauthorized-ir.directive';
import { AuthorizationByStatusModel } from 'src/app/shared/models/authorization-model';

@Component({
  selector: 'ness-crime-gun-irs',
  templateUrl: './crime-gun-irs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RemoveIfUnauthorizedIRDirective]
})
export class CrimeGunIrsComponent implements OnChanges {
  @Input() isPrintView: boolean = false;
  @Input() loading: boolean = false;

  private _relatedInfoReports: ServerModels.CrimeGunIntelligenceReportViewModel[] = [];
  public get relatedInfoReports(): ServerModels.CrimeGunIntelligenceReportViewModel[] {
    return this._relatedInfoReports;
  }

  @Input() public set relatedInfoReports(irs: ServerModels.CrimeGunIntelligenceReportViewModel[]) {
    this.loading = irs == null;
    this._relatedInfoReports = irs;

    if (irs != null) {
      this.toggleIconClass = irs.length > 0 ? 'fas fa-minus-square' : 'fas fa-plus-square';
    }
  }

  private _authOrgId: string[] = [];
  @Input() set authOrgId(ids: string[]) {
    this._authOrgId = ids?.map(x => x.toUpperCase()) || [];
  }

  get authOrgId(): string[] {
    return this._authOrgId;
  }

  @Output() showInfoReportDetails = new EventEmitter<ServerModels.CrimeGunIntelligenceReportViewModel>(true);
  @Output() addInfoReport = new EventEmitter();
  @Output() showInfoReportNotes = new EventEmitter<ServerModels.CrimeGunIntelligenceReportViewModel>();
  cols: any[] = [
    { field: 'Status', header: 'Status', sortable: true },
    { field: 'IntelligenceTrackingNumber', header: 'IR Tracking #', sortable: true },
    { field: 'CreatedByFullName', header: 'Created By', sortable: true },
    { field: 'CreatedOn', header: 'Created Date', sortable: true },
    { field: 'ModifiedByFullName', header: 'Last Updated By', sortable: true },
    { field: 'ModifiedOn', header: 'Last Updated Date', sortable: true },
    { field: 'PrimaryPointOfContact', header: 'Primary POC', sortable: true },
    { field: 'IsPrimaryCrimeGun', header: 'Primary Crime Gun', sortable: true },
    { field: 'Notes', header: 'Notes', sortable: false }
  ]
  rows: number = AppConstants.defaultTableRows;
  toggleIconClass: string = 'fas fa-minus-square';
  canCreateIR: AuthorizationByStatusModel = null;

  private _canViewIR: AuthorizationByStatusModel;
  get canView(): AuthorizationByStatusModel {
    this._canViewIR = AppPermissions.canViewIRs;
    this._canViewIR.authOrgCode = this.authService.authOrgCode;
    return this._canViewIR;
  }

  set canView(ir: AuthorizationByStatusModel) {
    this._canViewIR = ir;
  }

  constructor(private authService: AuthService,
    private infoReportSvc: InfoReportService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['authOrgId'] && changes['authOrgId'].currentValue != changes['authOrgId'].previousValue) {
      let hasCreate = this.authService.hasRole(['NESS Administrator']) || changes['authOrgId'].currentValue.includes(this.authService.authOrgCode?.toUpperCase());
      let newAuthModel = AppPermissions.canCreateIRs;
      newAuthModel.canCreate = hasCreate;
      this.canCreateIR = { ...newAuthModel };
    }
  }

  public canViewIR(ir: ServerModels.CrimeGunIntelligenceReportViewModel): AuthorizationByStatusModel {
    if (this.canView) {
      this.canView.assigneeIds = ir.AssignedCGICPersonnelIds;
    }
    return this._canViewIR;
  }

  public toggleClass(state: string): void {
    if (state === 'hide') {
      this.toggleIconClass = 'fas fa-plus-square';
    }
    if (state === 'show') {
      this.toggleIconClass = 'fas fa-minus-square';
    }
  }

  public onShowFullNotesClicked(data: ServerModels.CrimeGunIntelligenceReportViewModel) {
    this.showInfoReportNotes.emit(data);
  }
}
